import TextInput from '~/components/TextInput';
import React, { useContext, useEffect, useState } from 'react';
import usePublicPostApi from '~/public/lib/usePublicPostApi';
import * as ClientApi from '~/lib/ClientApi';
import ClientLogin from '~/components/forms/questions/components/ClientLogin';
import { useClientLogin } from '~/lib/useClientLogin';
import Loading from '~/components/Loading';
import { formatDateTime } from '~/lib/DateTime.js';
import { FormContext } from '~/components/forms/FormContext';
import usePrefillClientForm from '~/public/lib/usePrefillClientForm';
import ClientAccountIsLoggedIn from '~/components/forms/questions/components/ClientAccountIsLoggedIn.jsx';
import QuestionLabel from '~/components/forms/questions/QuestionLabel';

const ClientAccountQuestion = ({ value, setValue, settings, label }) => {
    const { isLoggedIn, isCheckingLogin, clientUser, data } = useClientLogin();

    useEffect(() => {
        setValue({ ...value, isLoggedIn: isLoggedIn });
    }, [isLoggedIn]);

    if (isCheckingLogin) {
        return <Loading message="Checking login..." />;
    }

    return (
        <div className={'py-4'}>
            {!isLoggedIn && <ClientLogin settings={settings} />}

            {!!clientUser && (
                <ClientAccountIsLoggedIn clientUser={clientUser} data={data} />
            )}
        </div>
    );
};

export default ClientAccountQuestion;
